import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR } from '../../actions/auth';
import { Map } from "immutable";

const auth = (state, action = {}) => {
    state = state || Map({
        isFetching: false,
        success: false,
        error: false,
        errorCode: '',
        payload: null
    });

    let newState;

    switch (action.type) {
        case RESET_PASSWORD_REQUEST:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error
            });
            break;
        case RESET_PASSWORD_SUCCESS:
            newState = state.merge({
                isFetching: action.isFetching,
                success: action.success,
                error: action.error
            });
            break;
        case RESET_PASSWORD_ERROR:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error,
                errorMessage: action.errorMessage
            });
            break;
        default:
            newState = state;
    }

    return newState;
};

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth/resetPassword.js